"use strict";

exports.__esModule = true;
exports.default = void 0;

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Home = _interopRequireDefault(require("@material-ui/icons/Home"));

var _Page = _interopRequireDefault(require("../../containers/Page"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

var _reactIntl = require("react-intl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    icon: {
      width: 192,
      height: 192,
      color: theme.palette.secondary.main
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: "100%"
    },
    paper: {
      backgroundColor: theme.palette.background.default,
      margin: 0,
      height: "calc(100vh - 64px)"
    },
    button: {
      marginTop: 20
    }
  };
});

var PageNotFound = function PageNotFound() {
  var intl = (0, _reactIntl.useIntl)();
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_Page.default, {
    pageTitle: intl.formatMessage({
      id: 'page_not_found'
    }) + ' MUI'
  }, /*#__PURE__*/_react.default.createElement(_Paper.default, {
    className: classes.paper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h4"
  }, "404"), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "subtitle1"
  }, intl.formatMessage({
    id: 'page_not_found'
  }) + ' MUI'), /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: "secondary",
    "aria-label": "home",
    href: "/",
    className: classes.button
  }, /*#__PURE__*/_react.default.createElement(_Home.default, null)))));
};

var _default = PageNotFound;
exports.default = _default;
module.exports = exports.default;